/* eslint-disable comma-spacing */
/* eslint-disable prefer-destructuring */
/* eslint-disable space-in-parens */
/* eslint-disable space-infix-ops */
/* eslint-disable no-multi-spaces */
/* eslint-disable object-curly-spacing */
/* eslint-disable indent */
/* eslint-disable keyword-spacing */
/* eslint-disable key-spacing */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-regex-literals */
/* eslint-disable no-unsafe-optional-chaining */
import React, {
  useState, useContext, useEffect,
  useMemo, useRef
} from 'react'
import { useDispatch,useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { PAYMENT_STATE, updatePaymentStates } from '@apps/redux/features/PayAndReviewSlice'
import { APPLICATION_STATE, ApplicationContext, setActivateAllTrigerred } from '@apps/contexts/ApplicationContext'
import BodyError from '@apps/components/Typography/BodyError'
import { PAYMENT_OPTIONS, CARD_VALIDATION_ERRORS } from '@apps/utils/constants'
import  CreditCardForm  from './CreditCardFormEPS'

const EPSCard = (
  {
      handleSIMActivation,
      textContent,
      setButtonIsLoading,
      hasInsufficientVoucherCodeError = false,
      voucherRequiredRef,
      validCreditCardContent
  }
  ) => {
    const dispatch = useDispatch()

  const {
      [APPLICATION_STATE.SERVICES]: brandServices,
      [APPLICATION_STATE.CURRENT_LANGUAGE]: language
    } = useContext(ApplicationContext)

    const paymentState = useSelector((state) => state.payAndReviewPage)

  const {
    [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: triggerValidation,
    [PAYMENT_STATE.PAYMENT_ALLOWED_COUNTRY_CODES]: paymentAllowedCountryCodes,
    [PAYMENT_STATE.PAYMENT_CVV_RESP_VAL]: paymentcvvResponseValue,
    [PAYMENT_STATE.PAYMENT_AVS_POSTAL_RESP_VAL]: paymentAvsPostalResponse,
    [PAYMENT_STATE.PAYMENT_ADDRESS_RESP_VAL]: paymentAddressResponseVal,
    [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: ccApiValidationError,
    [PAYMENT_STATE.VOUCHER.ADDED_VOUCHERS]: addedVouchers,
    [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: selectedPaymentOption,
    [PAYMENT_STATE.TERMS_OF_SERVICE]: isTermsConditionsChecked,
    [PAYMENT_STATE.CC_INFO.BILLING_ADDRESS]: billingAddress,
    [PAYMENT_STATE.CC_INFO.BILLING_ADDRESS_SELECTED]: selectedBillingAddress
  } = paymentState

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const { retrievePaymentSession } = brandServices

  const classes = {
      errorText: 'mvne-text-danger-100',
      rowOneClass: 'mb-11'
  }

  const [cardErrorMessage, setCardErrorMessage] = useState(null)
  const [cardErrorCode, setCardErrorCode] = useState(null)
  const [cardInputErrorCode, setCardInputErrorCode] = useState(null)
  const [showCardError, setShowCardError] = useState(false)
  const [expiryErrorMessage, setExpiryErrorMessage] = useState(null)
  const [cvvErrorMessage, setCvvErrorMessage] = useState(null)

  const [expiryErrorCode, setExpiryErrorCode] = useState(null)
  const [cvvErrorCode, setCvvErrorCode] = useState(null)
  
  const [expiryInputErrorCode, setExpiryInputErrorCode] = useState(null)
  const [cvvInputErrorCode, setCvvInputErrorCode] = useState(null)

  const [showExpiryDateError, setShowExpiryDateError] = useState(false)
  const [showCVVError, setShowCVVError] = useState(false)

  const [postalCodeErrorMessage, setPostalCodeErrorMessage] = useState(null)
  const [postalCodeValue, setPostalCodeValue] = useState('')
  const [billingAddressErrorMessage, setBillingAddressErrorMessage] = useState(null)

  const [payClient, setPayClient] = useState(null)
  // Raised while a spent session is being replaced. Deliberately NOT derived from
  // payClient being absent: that is also true for the moment every mount spends
  // awaiting its first session token, which would block the customer during normal
  // startup (see NGA PR #1964).
  const [isRefreshingPaymentForm, setRefreshingPaymentForm] = useState(false)
  const cardApiErrorRef = useRef(null)
  
  useEffect(() => {
    if(hasInsufficientVoucherCodeError && voucherRequiredRef) {
      // Was `ref?.current !== undefined ?? ref?.current.scrollIntoView(...)`, which
      // never scrolled: the left side is a boolean, so it is never nullish and ??
      // never evaluated the right side. An `if` was meant. no-unused-expressions
      // is disabled for this file, so nothing flagged the dangling expression.
      voucherRequiredRef?.current?.scrollIntoView({
        behavior: "smooth"
      })
    }

    if(triggerValidation && !hasInsufficientVoucherCodeError) {
      validateCardDetails()
    }
  }, [triggerValidation])

  // Clear the required error as soon as an address is entered, mirroring the
  // onFocus-clear behaviour of the postal field. Continue re-runs
  // showBillingAddressError, so an unselected address is still blocked there.
  useEffect(() => {
    if (billingAddress) {
      setBillingAddressErrorMessage('')
    }
  }, [billingAddress])

  // Free text the customer typed without picking a suggestion is not a real
  // address, so it must block Continue the same way an empty field does —
  // otherwise the field is only highlighted and the activation goes through.
  const showBillingAddressError = () => {
    if (!billingAddress) {
      setBillingAddressErrorMessage(textContent?.shortTextFields?.billingAddressRequired)
      return true
    }
    if (billingAddress !== selectedBillingAddress) {
      setBillingAddressErrorMessage(
        textContent?.shortTextFields?.billingAddressNotSelected
        || textContent?.shortTextFields?.billingAddressRequired
      )
      return true
    }
    setBillingAddressErrorMessage('')
    return false
  }

  useEffect( () => {
    /* istanbul ignore next */
    if(showCardError) {
      if(cardInputErrorCode === null) {
        setCardErrorCode('empty_field')
      } else {
        setCardErrorCode(cardInputErrorCode)
      }
    } else {
      setCardErrorCode('')
    }
  }, [showCardError, cardInputErrorCode])

  useEffect( () => {
    /* istanbul ignore next */
    if(cardErrorCode) {
      showCardNumberError(cardErrorCode)
    } else {
      setCardErrorMessage('')
    }
  }, [cardErrorCode])

  useEffect( () => {
    /* istanbul ignore next */
    if(showCVVError) {
      if(cvvInputErrorCode === null) { // means initial fields user not started typing clicked inside field and blur
        setCvvErrorCode('empty_field')
        updatePaymentStore({[PAYMENT_STATE.CC_INFO.SECURITY_CODE_ERROR] : 'empty_field'})
      } else {
        setCvvErrorCode(cvvInputErrorCode)
        updatePaymentStore({[PAYMENT_STATE.CC_INFO.SECURITY_CODE_ERROR] : cvvInputErrorCode})
      }
    } else {
      setCvvErrorCode('')
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.SECURITY_CODE_ERROR] : ''})
    }

  }, [showCVVError])

  
  useEffect( () => {
    /* istanbul ignore next */
    if(showExpiryDateError) {

      if(expiryInputErrorCode === null) { // means initial fields user not started typing clicked inside field and blur
        setExpiryErrorCode('empty_field')
        updatePaymentStore({[PAYMENT_STATE.CC_INFO.EXPIRY_DATE_ERROR] : 'empty_field'})
      } else {
        setExpiryErrorCode(expiryInputErrorCode)
        updatePaymentStore({[PAYMENT_STATE.CC_INFO.EXPIRY_DATE_ERROR] : expiryInputErrorCode})
      }
    } else {
      setExpiryErrorCode('')
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.EXPIRY_DATE_ERROR] : ''})
    }

  }, [showExpiryDateError])

  useEffect( () => {
    /* istanbul ignore next */
    if(expiryErrorCode) {
      generateExpiryDateError(expiryErrorCode)
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.EXPIRY_DATE_ERROR] : expiryErrorCode})
    } else {
      setExpiryErrorMessage('')
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.EXPIRY_DATE_ERROR] : ''})
    }
  }, [expiryErrorCode])

  useEffect( () => {
    /* istanbul ignore next */
    if(cvvErrorCode) {
      generateCVVError(cvvErrorCode)
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.SECURITY_CODE_ERROR] : cvvErrorCode})
    } else {
      setCvvErrorMessage('')
      updatePaymentStore({[PAYMENT_STATE.CC_INFO.SECURITY_CODE_ERROR] : ''})
    }
  }, [cvvErrorCode])

  /*
    The SDK injects one iframe per hosted field into our container divs and offers
    no way to swap the session token on an existing field - the token is baked into
    each iframe's URL. So a rebuild has to start by removing what is already there,
    otherwise addField() stacks a second iframe on top of the first and the customer
    sees duplicated inputs.

    client.remove() is called first where the SDK exposes it, so the window message
    listener its constructor attached comes off with it; it is wrapped because the
    SDK's own remove() assumes its iframes are still attached, which is not
    guaranteed after a re-render. The explicit node removal below is what actually
    guarantees a clean container either way.
  */
  const removeExistingHostedFields = () => {
    try {
      payClient?.remove?.()
    } catch (_removeError) {
      // The client is being discarded regardless; a failed teardown must not stop
      // the rebuild, or the customer is left with no usable form at all.
    }

    const fieldIds = ['iframe_cardNumber', 'iframe_expiryDate', 'iframe_cvv']
    fieldIds.forEach((id) => {
      const iframe = document.getElementById(id)
      /* istanbul ignore next */
      if (iframe?.parentNode) {
        iframe.parentNode.removeChild(iframe)
      }
    })
  }

  /*
    An EPS session is consumed by payClient.tokenize() whether or not we go on to
    accept the response, so every retry has to run against a freshly minted session
    - otherwise EPS answers 40002 "Invalid payment session token" and the customer
    cannot recover without reloading the page.

    Rebuilding the hosted fields necessarily clears the card number, expiry and CVV
    the customer entered, because the session token lives in each field's iframe
    URL. The field-presence codes and inline errors are therefore reset alongside
    the rebuild; otherwise the now-empty fields would still pass validateCardDetails
    as though they were filled in. The postal code and billing address are our own
    inputs, not hosted fields, so they survive.
  */
  const resetEpsPaymentForm = async () => {
    // Keeps a fast second click from tokenizing against the spent session while
    // the replacement is still in flight.
    setRefreshingPaymentForm(true)

    let refreshed = false
    try {
      refreshed = await createEpsPaymentForm()
    } catch (_refreshError) {
      refreshed = false
    }

    if (!refreshed) {
      // The session could not be replaced, so payClient is still bound to the spent
      // one. Leave the field state untouched - clearing it here would mark filled
      // fields as empty - and leave the refresh flag raised rather than inviting a
      // retry that cannot succeed. The caller has already surfaced a payment error;
      // recovery needs a page reload.
      return
    }

    // Only now that new, empty hosted fields are installed: line our state up with
    // what the customer can actually see. null is the "untouched" value the input
    // listeners start from, which is what an empty field is.
    setCardInputErrorCode(null)
    setExpiryInputErrorCode(null)
    setCvvInputErrorCode(null)
    setShowCardError(false)
    setShowExpiryDateError(false)
    setShowCVVError(false)
    setRefreshingPaymentForm(false)
  }

  const createEpsPaymentForm = async () => {
    const sessionResp = await retrievePaymentSession()
    const { data: bearer } = sessionResp

    // retrievePaymentSession resolves to an error object rather than throwing, and
    // feeding that into epsClient.init() yields a client that cannot tokenize.
    // Bail out before the existing fields are torn down below, so a failed refresh
    // leaves the working form standing instead of blanking it. The false return
    // tells resetEpsPaymentForm() that nothing was rebuilt.
    if (typeof bearer !== 'string' || bearer.length === 0) {
      return false
    }

    const options = {
        font: "16px Roboto, Open Sans, Segoe UI, sans-serif",
        fontColor: "#394056",
        backgroundColor: "#fff",
        placeHolderColor: "#6A7080"
      };

      // On a refresh the previous hosted fields are still in their containers.
      // addField() would inject a second iframe alongside each one, so clear them
      // first - the session token is baked into each iframe URL, which is why the
      // fields cannot be carried over to the new session.
      removeExistingHostedFields()

      const client = epsClient.init(bearer, options);
      setPayClient(client)

      const cardNumberInput = client.addField("cardNumber", "CardNumber", {
        placeHolder: " ", 
      })

      const expiryDateInput = client.addField("expiryDate", "ExpiryDate", {
        placeHolder: " ",
      })
  
      const cvvInput = client.addField("cvv", "Cvv", {
        placeHolder: " ", 
      })

      const iframeExpiry = document.getElementById('iframe_expiryDate')
      const iframeCvv = document.getElementById('iframe_cvv')
      /* istanbul ignore next */
      if (iframeExpiry && iframeCvv) {
        iframeExpiry.setAttribute("width", "369");
        iframeExpiry.setAttribute("height", "48");
        iframeExpiry.style.paddingTop = '3px'
        iframeExpiry.style.paddingBottom = '3px'
        iframeExpiry.style.marginTop = '2px'
        iframeCvv.setAttribute("width", "174");
        iframeCvv.setAttribute("height", "48");
        iframeCvv.style.paddingTop = '3px'
        iframeCvv.style.paddingBottom = '3px'
        iframeCvv.style.marginTop = '2px'
      }
      const iframeCard = document.getElementById('iframe_cardNumber')
      /* istanbul ignore next */
      if (iframeCard) {
        iframeCard.style.marginLeft = '44px'
        iframeCard.style.marginTop = '3px'
        iframeCard.style.width = 'calc(100% - 44px)'
        iframeCard.setAttribute("height", "48");
        iframeCard.style.paddingTop = '3px'
        iframeCard.style.paddingBottom = '3px'
      }
      /* istanbul ignore next */
      cardNumberInput?.addEventListener("blur", () => {
        setShowCardError(true)
      })
      /* istanbul ignore next */
      cardNumberInput?.addEventListener("input", (e) => {
        if(e.detail.error.code) {
          setCardInputErrorCode(e.detail.error.code)
        } else {
          setCardInputErrorCode('')
        }
      })
      /* istanbul ignore next */
      cardNumberInput?.addEventListener("focus", () => {
        setShowCardError(false)
      })
      /* istanbul ignore next */
      expiryDateInput?.addEventListener("blur", () => {
        setShowExpiryDateError(true)
      })
      /* istanbul ignore next */
      expiryDateInput?.addEventListener("input", (e) => {

        if(e.detail.error.code) {
          setExpiryInputErrorCode(e.detail.error.code)
        } else {
          setExpiryInputErrorCode('')
        }

      })
      /* istanbul ignore next */
      cvvInput?.addEventListener("blur", () => {
        setShowCVVError(true)
      })
      /* istanbul ignore next */
      cvvInput?.addEventListener("input", (e) => {
        if(e.detail.error.code) {
          setCvvInputErrorCode(e.detail.error.code)
        } else {
          setCvvInputErrorCode('')
        }
    
      })
      /* istanbul ignore next */
      expiryDateInput?.addEventListener("focus", () => {
        setShowExpiryDateError(false)
      })
      /* istanbul ignore next */
      cvvInput?.addEventListener("focus", () => {
        setShowCVVError(false)
      })

      // Signals to resetEpsPaymentForm() that a new client and a new set of empty
      // hosted fields are installed, so it is safe to line our state up with them.
      return true
  }

  useEffect(() => {
    createEpsPaymentForm()
  }, [])

  // A mount means a fresh session and empty fields, so a card verdict left in
  // redux describes an attempt that no longer exists. It also feeds
  // PaymentCompleteEPS, so a stale one holds isCompleteEPS false and blocks the
  // navigation to the process loader. Mount only: listing ccApiValidationError
  // would clear it the moment a rejection raised it.
  useEffect(() => {
    if (ccApiValidationError) {
      updatePaymentStore({ [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: '' })
    }
  }, [])

  useEffect( () => {
    /* istanbul ignore next */
    if(cardErrorCode) {
      showCardNumberError(cardErrorCode)
    }

    if(expiryErrorCode) {
      generateExpiryDateError(expiryErrorCode)
    }

    if(cvvErrorCode) {
      generateCVVError(cvvErrorCode)
    }

    if(postalCodeErrorMessage) {
      showPostalCodeError()
    }

    if(billingAddressErrorMessage) {
      showBillingAddressError()
    }

  }, [language])

  const cardApiValidationError = useMemo(() => {
    if (!ccApiValidationError) return ""
    if (ccApiValidationError === CARD_VALIDATION_ERRORS.UNAUTHORIZED) {
      return textContent?.shortTextFields?.paymentSessionExpiredError
    }
    return textContent?.shortTextFields?.cannotProcessCreditCard
  }, [language, ccApiValidationError])

  useEffect(() => {
    if (!(isMobile && ccApiValidationError && cardApiErrorRef?.current)) return

    const scrollTimer = setTimeout(() => {
      // align near the top but nudged slightly higher than block: 'start'
      const { top } = cardApiErrorRef.current.getBoundingClientRect()
      const y = Math.max(window.pageYOffset + top - 40, 0)
      window.scrollTo({ top: y, behavior: 'smooth' })
    }, 80) // allow child field scrolls to finish on mobile

    return () => {
      clearTimeout(scrollTimer)
    }
  }, [ccApiValidationError])

  /* istanbul ignore next */
  const showCardNumberError = (code) => {
    switch(code) {
      case 'empty_field':
        setCardErrorMessage(textContent?.shortTextFields?.cardNumberRequired)
        break
      case 'incomplete_pan':
      case 'invalid_card':
        setCardErrorMessage(textContent?.shortTextFields?.cardNumberInvalid)
        break
      default:
        setCardErrorMessage(textContent?.shortTextFields?.cardNumberInvalid)
        console.error(code)
        break
    }
  }

  /* istanbul ignore next */
  const generateCVVError = (code, msg) => {

    switch(code) {
      case 'empty_field':
        setCvvErrorMessage(textContent?.shortTextFields?.securityCodeRequired)
        break;
      case 'incomplete_cvv':
        setCvvErrorMessage(textContent?.shortTextFields?.securityCodeInvalid)
        break;
      default:
        setCvvErrorMessage(textContent?.shortTextFields?.securityCodeInvalid)
        console.error(code)
        break
    }
   
  }

  /* istanbul ignore next */
  const generateExpiryDateError = (code, msg) => {

    switch(code) {
      case 'empty_field':
        setExpiryErrorMessage(textContent?.shortTextFields?.expiryDateRequired)
        break
      case 'incomplete_date':
        setExpiryErrorMessage(textContent?.shortTextFields?.expiryDateInvalidFormat)
        break
      case 'past_date':
        setExpiryErrorMessage(textContent?.shortTextFields?.expiryDateExpired)
        break
      default:
        setExpiryErrorMessage(textContent?.shortTextFields?.expiryDateInvalidFormat)
        console.error(code)
        break
    }
 
  }

  /*
    EPS rejects a spent session with code 40002 / "Invalid payment session token",
    not with 401 - confirmed against the sandbox while reproducing MASC-16812. Only
    401 was handled before, so the real spent-session case fell through to the
    generic branch and told the customer to "try again with a different credit
    card", which cannot work: the session is the problem, not the card.

    Codes arrive as a number or a string depending on the failure, so compare
    loosely against both spellings rather than trusting one.
  */
  const SESSION_REJECTION_CODES = [401, '401', 40002, '40002']

  const isSessionRejection = (res) => {
    if (!res?.error) {
      return false
    }
    // A containerId means the SDK rejected a field locally, without reaching EPS,
    // so whatever the code says the session was never involved.
    if (res?.containerId) {
      return false
    }
    return SESSION_REJECTION_CODES.includes(res?.error?.code)
  }

  /*
    Whether the attempt reached EPS, and therefore burned the session.

    This is deliberately NOT the same question as isSessionRejection() above,
    which picks the error *message*. The session is spent by the request being
    processed, whatever EPS then answers - 40026 "Downstream error processing
    request in Global Payments" leaves it just as dead as 40002 does, even though
    nothing about the session was wrong and the customer's card is fine.

    Gating the refresh on an enumerated list of codes was the original defect:
    only 401 and 40002 were known when this was written, so 40026 fell through,
    no replacement session was minted, and the retry tokenized against the spent
    one - the exact failure MASC-16812 set out to fix, reached by a different code.

    A containerId is the one signal that the request never left the SDK, so the
    session survives and rebuilding would throw away fields the customer filled in
    correctly. Everything else is treated as spent, including a response too
    malformed to classify: the costs are asymmetric. An unnecessary refresh makes
    them re-enter the card; a missed one guarantees a 40002 on the next press and
    makes them re-enter it anyway, a wasted click later.
  */
  const isSessionSpent = (res) => {
    if (res?.containerId) {
      return false
    }
    return true
  }

  const isValidCardIssuer = (issuerCountry) => {
    if(paymentAllowedCountryCodes.includes('All countries')) {
      return true
    }
    if(paymentAllowedCountryCodes.includes(issuerCountry)) {
      return true
    }
    return false
  }

  const isFraudDetected = ({avsAddressResponse = '', avsPostalCodeResponse = '', cvvResponse = ''}) => {

    if(!paymentAddressResponseVal.includes(avsAddressResponse) ||
        !paymentAvsPostalResponse.includes(avsPostalCodeResponse) ||
        !paymentcvvResponseValue.includes(cvvResponse)) {
      return true
    }
    return false

  }
  /* istanbul ignore next */
  const validateCardDetails = async () => {

    // A rebuild is in flight, so payClient is still the spent one and the hosted
    // fields are about to be replaced. Tokenizing now would burn the click on a
    // session EPS will not accept. Clear the trigger so the next press is still
    // seen as a fresh false -> true transition, and drop the loader.
    if (isRefreshingPaymentForm) {
      setButtonIsLoading(false)
      updatePaymentStore({[PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false})
      return
    }

    let isValidForm = true
    const address = {
      line1: billingAddress,
      postalCode: postalCodeValue
    }

  if(cardInputErrorCode === null || cardInputErrorCode) {
    setShowCardError(true)
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD] : 'cardNumber'})
    }
    isValidForm = false
  }
  if(expiryInputErrorCode === null || expiryInputErrorCode) {
    setShowExpiryDateError(true)
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD] : 'expiryDate'})

    }
    isValidForm = false
  }
  if(cvvInputErrorCode === null || cvvInputErrorCode) {
    setShowCVVError(true)
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD] : 'cvv'})
    }
    isValidForm = false
  }

  const isPostalCodeInvalid =  showPostalCodeError()

  if(isPostalCodeInvalid) {
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'postal'})
    }
    isValidForm = false
  }

  const isBillingAddressInvalid = showBillingAddressError()

  if(isBillingAddressInvalid) {
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'billingAddress'})
    }
    isValidForm = false
  }

  if(!isTermsConditionsChecked) {
    if(isValidForm) {
      updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD] : 'tnc'})
    }
    isValidForm = false
  }

  if(selectedPaymentOption === PAYMENT_OPTIONS.VOUCHER && addedVouchers.length === 0) {
    isValidForm = false
  }

  if (!isValidForm) {
    setButtonIsLoading(false)
    updatePaymentStore({[PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false})
    return
  }

  setActivateAllTrigerred(true)
  setButtonIsLoading(true)
  updatePaymentStore({[PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: ''})

  const res = await payClient.tokenize(address)

    if (res?.id && res?.cardInfo) {

      if(isFraudDetected(res)) {
        updatePaymentStore({
          [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false,
          [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: CARD_VALIDATION_ERRORS.FAILED,
          ...(!isMobile && { [PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cardNumber' })
        })
        setButtonIsLoading(false)
        // ActivationMount renders a fixed, full-screen div for as long as this flag
        // is raised, so returning without lowering it leaves the customer unable to
        // click anything at all - not even the retry this error invites.
        setActivateAllTrigerred(false)

        // EPS has already recorded a SUCCESS against this session, so the form must
        // be moved onto a new one before the customer can try again.
        await resetEpsPaymentForm()

        // disable payment btn check
        return
      }

      if(!isValidCardIssuer(res?.cardInfo?.countryOfIssue)) {
        // undefined here, EPS accepted the card and we declined it because
        updatePaymentStore({
          [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false,
          [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: CARD_VALIDATION_ERRORS.FAILED,
          ...(!isMobile && { [PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cardNumber' })
        })
        setButtonIsLoading(false)
        // Same dead end as the branch above: without this the page freezes under
        // ActivationMount's full-screen overlay and only a reload escapes.
        setActivateAllTrigerred(false)

        await resetEpsPaymentForm()
        return
      }

      const maskedCardNumber = `${res?.cardInfo?.bin??'******'}******${res?.cardInfo?.lastFourDigits??'****'}`
      setButtonIsLoading(false)
      handleSIMActivation({
        STORAGE_TOKEN_ID: res?.id,
        STORAGE_TOKEN_EXPIRY: res?.cardInfo?.expiryMonth + res?.cardInfo?.expiryYear,
        CARD_NUMBER: maskedCardNumber
      })

      updatePaymentStore({
        [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false,
        [PAYMENT_STATE.CC_INFO.CREDIT_CARD_NUMBER]: maskedCardNumber
      })

    } else {

      // highlight erroneous fields
      if(res?.error ) {
        // disable payment btn
        if(res?.containerId === 'CardNumber') {
          showCardNumberError(res?.error?.code, res?.error?.message)
          updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cardNumber'})
        } else if(res?.containerId === 'ExpiryDate') {
          generateExpiryDateError(res?.error?.code, res?.error?.message)
          updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'expiryDate'})
        } else if(res?.containerId === 'Cvv') {
          generateCVVError(res?.error?.code, res?.error?.message)
          updatePaymentStore({[PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cvv'})
        } else if(isSessionRejection(res)) {
          updatePaymentStore({
            [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR] : CARD_VALIDATION_ERRORS.UNAUTHORIZED,
            ...(!isMobile && { [PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cardNumber' })
          })
        } else {
          updatePaymentStore({
            [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR] : CARD_VALIDATION_ERRORS.FAILED,
            ...(!isMobile && { [PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: 'cardNumber' })
          })
        }
      }

      // Unlike the two post-tokenize rejection branches above, a failed tokenize
      // lowers the scrim, so a mistyped card number stays recoverable.
      setActivateAllTrigerred(false)
      setButtonIsLoading(false)

      updatePaymentStore({[PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false})

      // Any attempt that reached EPS has burned the session, so the form is now
      // bound to one EPS will not accept again and retrying on it is guaranteed
      // to fail. Field errors are the deliberate exception: the SDK raises those
      // locally without calling EPS, so the session is still good and rebuilding
      // would throw away the values the customer entered correctly.
      if (isSessionSpent(res)) {
        await resetEpsPaymentForm()
      }

    }

  }

  const onChangePostalCode = (value) => {

      const firstLetterMatch = new RegExp(/([abceghjklmnprstvxyABCEGHJKLMNPRSTVXY])/)
      const letterMatch = new RegExp(/([abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ])/)
      const digitMatch = new RegExp(/\d/)

      // Canadian postal codes display uppercase
      const stringArray = value.toUpperCase().split('')

      if (stringArray.length > 3 && stringArray.indexOf(' ') === -1) {
        stringArray.splice(3, 0, ' ')
      }
      const letters = [0, 2, 5]
      const numbers = [1, 4, 6]

      let matches = true

      stringArray.forEach((char, i) => {
        if (letters.indexOf(i) !== -1) {
          if (i === 0 && !char.match(firstLetterMatch)) {
            matches = false
          } else if (!char.match(letterMatch)) {
            matches = false
          }
        } else if (numbers.indexOf(i) !== -1) {
          if (!char.match(digitMatch)) {
            matches = false
          }
        }
      })
      if (matches) {
        const result = stringArray.join('')
        setPostalCodeValue(result)
        updatePaymentStore({[PAYMENT_STATE.CC_INFO.POSTAL_CODE]: result})
      }

  }

  const showPostalCodeError = () => {

    const value = postalCodeValue
    if (value === '') {
      setPostalCodeErrorMessage(textContent?.shortTextFields?.postalZipRequired)
      return true
    }
    const postalMatch = new RegExp(
      /([abceghjklmnprstvxyABCEGHJKLMNPRSTVXY])\d([abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ])(.?)\d([abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ])\d/g
    )
    if (!value.match(postalMatch)) {
      setPostalCodeErrorMessage(textContent?.shortTextFields?.postalZipInvalid)
      return true
    }
    setPostalCodeErrorMessage('')
    return false

  }

  const onBlurPostalCode = () => {
    showPostalCodeError()
  }

  const onFocusPostalCode = () => {
    setPostalCodeErrorMessage('')
  }

  return (
    <div className="space-y-4">

      {cardApiValidationError && (
        <div ref={cardApiErrorRef}>
          <BodyError>
            {cardApiValidationError}
          </BodyError>
        </div>
      )}

      <div>
        <CreditCardForm 
            cardErrorMessage={cardErrorMessage}
            cardNumberLabel={textContent?.shortTextFields?.cardNumber}
            postalCodeLabel={textContent?.shortTextFields?.postalCode}
            postalErrorMessage={postalCodeErrorMessage}
            valuePostal={postalCodeValue}
            onChangePostal={onChangePostalCode}
            onBlurPostal={onBlurPostalCode}
            onFocusPostal={onFocusPostalCode}
            expiryDateLabel={textContent?.shortTextFields?.expiryDate}
            expiryErrorMessage={expiryErrorMessage}
            labelSecurityCode={textContent?.shortTextFields?.securityCode}
            cvvErrorMessage={cvvErrorMessage}
            billingAddressLabel={textContent?.shortTextFields?.billingAddress}
            billingAddressPlaceholder={textContent?.shortTextFields?.billingAddressPlaceholder}
            billingAddressLoadingLabel={textContent?.shortTextFields?.billingAddressLoadingLabel}
            billingAddressNoResults={textContent?.shortTextFields?.billingAddressNoResults}
            billingAddressErrorMessage={billingAddressErrorMessage}
            onBlurBillingAddress={showBillingAddressError}
            postalCodeTooltip={textContent?.shortTextFields?.postalCodeTooltip}
            cvvTooltip={textContent?.shortTextFields?.securityCodeTooltip}
            validCreditCardContent={validCreditCardContent}
        />
      </div>

    </div>
  )
}

export default EPSCard
